'use client';

import { map } from 'lodash-es';
import React, { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import EventListing from './event-listing';
import { Event } from '../types/Event/Event';
import { Group } from '../types/Group/Group';

const useStyles = makeStyles()((theme: Theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
  list: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
  },
  listItem: {
    padding: 0,
  },
}));

type EventListProps = {
  events?: Event[];
  group?: Group;
  emptyMessage?: string;
  className?: string;
  fullDate?: boolean;
}

const EventList: FC<EventListProps> = ({ events, emptyMessage = 'No upcoming events', group, className, ...rest }) => {
  const { classes, cx } = useStyles();

  if (!events || !events.length) {
    return <p className={className}>{emptyMessage}</p>;
  }

  return (
    <Paper className={classes.paper}>
      <ul className={cx(classes.list, className)}>
        {map(events, (event, index) => {
          return (
            <li className={classes.listItem} key={event.id}>
              {index > 0 && <Divider sx={{ my: 2 }} />}
              <EventListing
                event={event}
                group={group}
                {...rest}
              />
            </li>
          );
        })}
      </ul>
    </Paper>
  );
};

export default EventList; 